import React from 'react';

export function StatusBadge({ status }) {
  const colors = {
    pending: 'bg-slate-100 text-slate-700 border border-slate-200',
    running: 'bg-amber-100 text-amber-800 border border-amber-200',
    completed: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
    failed: 'bg-rose-100 text-rose-800 border border-rose-200',
    draft: 'bg-slate-100 text-slate-700 border border-slate-200',
    ready: 'bg-emerald-100 text-emerald-800 border border-emerald-200',
    archived: 'bg-orange-100 text-orange-700 border border-orange-200',
    void: 'bg-rose-100 text-rose-700 border border-rose-200',
  };
  return (
    <span
      className={`rounded-full px-1.5 py-0.5 text-[9px] font-semibold uppercase ${
        colors[status] || 'bg-slate-100 text-slate-700 border border-slate-200'
      }`}
    >
      {status || '—'}
    </span>
  );
}
